import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="bg-gray-800 text-white py-12">
            <div className="container mx-auto px-4">
                <div className="flex flex-wrap -mx-4">
                    <div className="w-full md:w-1/3 px-4 mb-8 md:mb-0">
                        <h3 className="text-2xl font-semibold mb-4">About Bilih</h3>
                        <p className="text-gray-400">Bilih is dedicated to innovating the way we live by providing cutting-edge tech solutions.</p>
                    </div>
                    <div className="w-full md:w-1/3 px-4 mb-8 md:mb-0">
                        <h3 className="text-2xl font-semibold mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li><Link to="/" className="text-gray-400 hover:text-white transition-colors duration-300">Home</Link></li>
                            <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-300">About</Link></li>
                            <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors duration-300">Services</Link></li>
                            <li><Link to="/portfolio" className="text-gray-400 hover:text-white transition-colors duration-300">Portfolio</Link></li>
                            <li><Link to="/testimonials" className="text-gray-400 hover:text-white transition-colors duration-300">Testimonials</Link></li>
                            <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors duration-300">Contact</Link></li>
                        </ul>
                    </div>
                    <div className="w-full md:w-1/3 px-4">
                        <h3 className="text-2xl font-semibold mb-4">Newsletter</h3>
                        <p className="text-gray-400 mb-4">Stay updated with our latest news and offers.</p>
                        <form className="flex">
                            <input type="email" placeholder="Your Email" className="flex-grow px-3 py-2 bg-gray-700 text-white rounded-l-md focus:outline-none focus:ring-2 focus:ring-bilih-blue" required />
                            <button type="submit" className="bg-bilih-blue text-white px-4 py-2 rounded-r-md hover:bg-bilih-green transition-colors duration-300">Subscribe</button>
                        </form>
                    </div>
                </div>
                <hr className="border-gray-700 my-8" />
                <div className="text-center">
                    <p>&copy; 2024 Bilih. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;